import { Component, OnInit, HostBinding } from '@angular/core';

@Component({
  selector: 'app-contact-layout',
  templateUrl: './contact-layout.component.html',
  styleUrls: ['./contact-layout.component.scss']
})
export class ContactLayoutComponent {
  @HostBinding('class') readonly hostClasses = 'has-navbar-fixed-top';
}
